import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../../components/landing"
import { medicareGuideZh } from "../../content/zh/medicare-levy-calculator"
import { guideSeo } from "../guides.$slug"

const PATH = "/medicare-levy-calculator"

/** Chinese version of /medicare-levy-calculator (D-WEB-LANG-SCOPE, T1320); the English route carries the hreflang pair too. */
export const medicareZhSeo = () => guideSeo(medicareGuideZh, PATH, "zh")

export const Route = createFileRoute("/_brand-layout/zh/medicare-levy-calculator")({
  head: () => {
    const { meta, links, scripts } = medicareZhSeo()
    return { meta, links, scripts }
  },
  component: MedicareZhPage,
})

export function MedicareZhPage() {
  return <GuidePage guide={medicareGuideZh} />
}
